import * as echarts from 'echarts';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import moment from 'moment';
import appstore from '@/pages/intelligence/assets/svg/marketprofile/appstore.svg';
import googleplay32 from '@/pages/intelligence/assets/svg/marketprofile/googleplay32.svg';
import mscience from '@/pages/intelligence/assets/svg/marketprofile/mscience.svg';
import steam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';
import epic from '@/pages/intelligence/assets/svg/dataSource/epic.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import newzoo from '@/pages/intelligence/assets/svg/marketprofile/newzoo.svg'

import numeral from 'numeral';
import { CountryItem } from '@intelligence/pages/MarketProfile/hooks/useCountriesHooks';
import { getPiecesDefault } from '@intelligence/v3/components/ChartComponents/MapChart/utils';

export const formatNumToNumber = (value) => {
  let num;
  if (value.indexOf('B') != -1) {
    num = Number(value.replace('B', '')) * 1000000000;
  } else if (value.indexOf('M') != -1) {
    num = Number(value.replace('M', '')) * 1000000;
  } else if (value.indexOf('K') != -1) {
    num = Number(value.replace('K', '')) * 1000;
  } else {
    return value;
  }
  return num;
};

export const computeMobileTopPrecent = (data) => {
  let temp = {
    revenueSumNum: 0,
    revenueSumPercent: 0,
    downloadSumNum: 0,
    downloadSumPercent: 0,
  };
  if (data) {
    const revenue = data?.rev || 0;
    const revenue_pre = data?.pre_rev || 0;
    const download = data?.downLoad || 0;
    const download_pre = data?.pre_download || 0;
    let revenue_precent = 0;
    let download_precent = 0;

    const revenueDiff = revenue - revenue_pre;
    if (revenue_pre == 0 && revenue != 0) {
      revenue_precent = 1;
    } else if (revenue_pre == 0 && revenue == 0) {
      revenue_precent = 0;
    } else if (revenue_pre != 0 && revenue != 0) {
      revenue_precent = revenueDiff / revenue_pre;
    } else {
      revenue_precent = 0;
    }

    const downloadDiff = download - download_pre;
    if (download_pre == 0 && download != 0) {
      download_precent = 1;
    } else if (download_pre == 0 && download == 0) {
      download_precent = 0;
    } else if (download_pre != 0 && download != 0) {
      download_precent = downloadDiff / download_pre;
    } else {
      download_precent = 0;
    }

    temp = {
      revenueSumNum: revenue,
      revenueSumPercent: revenue_precent,
      downloadSumNum: download,
      downloadSumPercent: download_precent,
      revenueDiff,
      downloadDiff,
    };
  }
  return temp;
};

export const sortTime = (attr) => {
  return function (a, b) {
    const aValue = a[attr];
    const bValue = b[attr];
    return (
      new Date(aValue.split('-').join('/')).getTime() -
      new Date(bValue.split('-').join('/')).getTime()
    );
  };
};

// 数组根据对象某一属性值进行排序
export const sortArr = (attr) => {
  return function (a, b) {
    const aValue = a[attr];
    const bValue = b[attr];
    if (aValue == 0 && bValue == 0) {
      return b[attr] - a[attr];
    }
    if (aValue == 0 && bValue != 0) {
      return 1;
    }
    if (aValue != 0 && bValue == 0) {
      return -1;
    }
    if (aValue != 0 && bValue != 0) {
      return b[attr] - a[attr];
    }
  };
};

// 数组根据对象某一属性值进行排序 升序
export const sortArrDown = (attr) => {
  return function (a, b) {
    const aValue = a[attr];
    const bValue = b[attr];
    if (aValue === bValue) {
      return b[attr] - a[attr];
    }
    if (aValue < bValue) {
      return -1;
    }
    if (aValue > bValue) {
      return 1;
    }
  };
};

// totalRevenue  totalPlayer排序规则。
export const sortStr = (attr) => {
  return function (a, b) {
    const aValue = String(a[attr]);
    const bValue = String(b[attr]);
    const aNum = Number(aValue.substr(0, aValue.length - 1));
    const bNum = Number(bValue.substr(0, bValue.length - 1));
    if (aValue.indexOf('B') != -1 && bValue.indexOf('B') != -1) {
      // 都是B
      return bNum - aNum;
    }
    if (aValue.indexOf('B') != -1 && bValue.indexOf('B') == -1) {
      // 前一个是B，后一个是M
      return -1;
    }
    if (aValue.indexOf('B') == -1 && bValue.indexOf('B') != -1) {
      // 前一个是M，后一个是B
      return 1;
    }
    if (aValue.indexOf('B') == -1 && bValue.indexOf('B') == -1) {
      // 都是M
      return bNum - aNum;
    }
  };
};

export const sortStr2 = (attr) => {
  return function (a, b) {
    const aValue = a[attr];
    const bValue = b[attr];
    if (aValue == 'global') {
      return -1;
    }
    return 1;
  };
};

export const fixLineData = (array, index) => {
  const dif = index - array.length;
  for (let i = 0; i < dif; i++) {
    array.push('-');
  }
  return array;
};

export const formatEnNumber = (num) => {
  if (isNaN(num) || !num) {
    return '-';
  }
  return `${num}`.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
};

// 地图缩放
export const mapZoom = (containId, type) => {
  const chartDom = document.getElementById(containId);
  if (chartDom) {
    const myChart = echarts.getInstanceByDom(chartDom);
    const option = myChart.getOption();
    let mapZoomNow = option.series[0].zoom;
    if (type == 'zoomIn' && mapZoomNow < 15) {
      mapZoomNow++;
    } else if (type == 'zoomOut' && mapZoomNow > 1) {
      mapZoomNow--;
    }
    option.series[0].zoom = mapZoomNow;
    myChart.setOption(option);
  }
};

export const dealAnnualReportChartsData = (data, year) => {
  const xAxisData = [];
  Object.keys(data).map((key) => {
    if (key <= year) {
      xAxisData.push(key);
    }
  });
  xAxisData.sort();
  const mobileData = [];
  const pcData = [];
  const consoleData = [];
  xAxisData.map((item) => {
    const i = data[item];
    mobileData.push(Math.floor(i.mobile_rev * 100) / 100);
    pcData.push(Math.floor(i.pc_rev * 100) / 100);
    consoleData.push(Math.floor(i.console_rev * 100) / 100);
  });

  const series = [
    {
      name: 'Mobile',
      type: 'bar',
      barGap: '20%',
      label: {
        show: true,
        position: 'top',
        formatter(params) {
          return formatNum(params.value);
        },
      },
      data: mobileData,
    },
    {
      name: 'PC',
      type: 'bar',
      barGap: '20%',
      label: {
        show: true,
        position: 'top',
        formatter(params) {
          return formatNum(params.value);
        },
      },
      data: pcData,
    },
    {
      name: 'Console',
      type: 'bar',
      barGap: '20%',
      label: {
        show: true,
        position: 'top',
        formatter(params) {
          return formatNum(params.value);
        },
      },
      data: consoleData,
    },
  ];
  mpBarCharts('mpAnnualSummaryCharts', xAxisData, series);
};

// 柱状图
export const mpBarCharts = (containId, xAxisData, series) => {
  const chartDom = document.getElementById(containId);
  if (chartDom) {
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#376AE7', '#3ECBFF', '#4FCB87'],
      tooltip: {
        // backgroundColor:'#262832',
        trigger: 'axis',
        padding: [10, 12],
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: '#0076FF',
            opacity: '0.05',
          },
        },
        formatter: (params: any) => {
          let content = ``;
          params?.map((item) => {
            content += `<div style="width:100%;display:flex;justify-content: space-between;">
                                <div style="width:10px;">${item?.marker}</div>
                                <div style="width:calc(100% - 15px);display:flex;justify-content: space-between;">
                                    <div style="width:max-content;fontsize:12px;color:#D8DAE4;text-align:left;">${
                                      item.seriesName
                                    }</div>
                                    <div style="width:max-content;text-align:right;padding-left:20px;color:#EBECF1;">${formatNum(
                                      Math.floor(item.value),
                                    )}</div>
                                </div>

                            </div>`;
          });
          const safeNumber = (val: any): number => {
            const num = Number(val);
            return Number.isNaN(num) ? 0 : num;
          };
          const totalNum =
            safeNumber(params[1]?.value) + safeNumber(params[2]?.value) + safeNumber(params[0]?.value);

          const showContent = `<div style="width:auto;text-align:left;color:#D8DAE4;min-width:150px;">
                    <div style="padding-bottom:10px;display:flex;justify-content: space-between;">
                        <span style='color:#D8DAE4'>${params[0].axisValueLabel}</span>
                        <span style='color:#D8DAE4'>Revenue($)</span>
                    </div>
                    <div style="display:flex;justify-content: space-between;">
                        <span style='color:#D8DAE4'>All</span>
                        <span style='color:#EBECF1'>${formatNum(Math.floor(totalNum))}</span>
                    </div>
                    ${content}
                </div>`;
          return showContent;
        },
        backgroundColor: 'rgba(0, 0, 0, 0)',
      },
      grid: {
        top: '10%',
        right: '2%',
        width: '95%',
        bottom: '3%',
        containLabel: true,
      },
      legend: {
        show: false,
      },
      toolbox: {
        show: false,
      },
      xAxis: {
        type: 'category',
        axisTick: { show: false },
        data: xAxisData,
      },

      yAxis: {
        type: 'value',
        axisLine: {
          show: false,
        },
        axisLabel: {
          color: '#BBBBBB',
          formatter(value, index) {
            return formatNum(value);
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: '#E9E9E9',
          },
        },
      },
      series,
    };
    option && myChart.setOption(option, true);
    myChart.resize();
  }
};

export const sortTimeDesc = (attr) => {
  return function (a, b) {
    const aValue = a[attr];
    const bValue = b[attr];
    return (
      new Date(bValue.split('-').join('/')).getTime() -
      new Date(aValue.split('-').join('/')).getTime()
    );
  };
};

// 数组根据对象某一属性值进行排序
export const sortArrDesc = (attr: string, order?: any) => {
  if (!order) {
    order = 'desc';
  }
  return function (a, b) {
    let aValue = a[attr];
    let bValue = b[attr];
    let result = 0;
    if (aValue == '-') {
      aValue = 0;
    }
    if (bValue == '-') {
      bValue = 0;
    }
    if (aValue == 0 && bValue == 0) {
      result = b[attr] - a[attr];
    } else if (aValue == 0 && bValue != 0) {
      result = 1;
    } else if (aValue != 0 && bValue == 0) {
      result = -1;
    } else if (aValue != 0 && bValue != 0) {
      result = b[attr] - a[attr];
    }
    return order === 'desc' ? result : -result;
  };
};

const monthDic = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export const formatEnTimeByStr = (time, needDay = true) => {
  // console.log(time)
  let timeS = '-';
  if (time?.length == 10) {
    timeS = monthDic[time.substr(5, 2)];
    if (needDay) {
      timeS += ` ${time.substr(8, 2)}`;
    }
    timeS += `, ${time.substr(0, 4)}`;
  } else {
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    timeS = `${monthDic[month]}, ${year}`;
  }
  if (timeS == 'Jan, 1970') {
    timeS = moment().format(needDay ? 'MMM DD, YYYY' : 'MMM , YYYY');
  }
  return timeS;
};

export const formatTimeByEnTime = (time) => {
  let timeE = '';
  // "Apr 27, 2022"
  if (time?.length == 12) {
    timeE += time.substr(8, 4);
    timeE += '-';
    const month = time.substr(0, 3);
    Object.keys(monthDic).map((key) => {
      if (month == monthDic[key]) {
        timeE += key;
        timeE += '-';
      }
    });
    timeE += time.substr(4, 2);
  } else if (time?.length == 9) {
    // "Apr, 2022"
    timeE += time.substr(5, 4);
    timeE += '-';
    const month = time.substr(0, 3);
    Object.keys(monthDic).map((key) => {
      if (month == monthDic[key]) {
        timeE += key;
        timeE += '-';
      }
    });
    timeE += '01';
  }
  return timeE;
};

export const formatEnTimeByList = (time) => {
  if (time && time.length == 2) {
    const timeS = `${monthDic[time[0].substr(5, 2)]},${time[0].substr(0, 4)}`;
    const timeE = `${monthDic[time[1].substr(5, 2)]},${time[1].substr(0, 4)}`;
    if (timeS == timeE) {
      return timeS;
    }
    return `${timeS} ~ ${timeE}`;
  }
  const now = new Date();
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  if (month >= 1 && month <= 9) {
    // @ts-ignore
    month = `0${month}`;
  }
  return `${monthDic[month]},${year}`;
};

// 页面打点
export const pageOperation = async (pageId, buttonId, info = '跳转StoreRank板块') => {
  const openId = sessionStorage.getItem('openId');
  const params_1 = {
    logType: 'buttonLog',
    openId,
    buttonLog: {
      typeId: 'intelligence_pc',
      pageId,
      buttonId: pageId + buttonId,
      extInfo: info,
    },
  };
  await operationLog(params_1);
};

export const computePrecentChange = (num, preNum) => {
  let precent = 0;
  // if (num != 0 && preNum == 0) {
  //   precent = 1;
  // } else if
  if (preNum != 0 && num != 0) {
    precent = (num - preNum) / preNum;
  }
  return precent;
};

/**
 * 计算增长率
 * @param {Object} params - 计算增长率所需参数
 * @param {number} params.currNum - 当前数值
 * @param {number} params.preNum - 上一期数值
 * @param {number} [params.decimalPlaces=2] - 保留小数位数,默认2位
 * @returns {number} 增长率,以小数形式返回 (如0.12表示增长12%)
 */
export const calculGrowth = ({
  currNum,
  preNum,
  decimalPlaces = 2,
}: {
  currNum: number;
  preNum: number;
  decimalPlaces?: number;
}) => {
  try {
    if (typeof currNum !== 'number' || typeof preNum !== 'number')
      throw new Error(
        `currNum or preNum should be a Number type! typeof currNum ${typeof currNum} and typeof preNum ${typeof preNum}`,
      );
    if (preNum === 0) throw new Error('preNum cannot be zero');

    const scale = 10 ** decimalPlaces;

    const scaledCurrNum = numeral(currNum).multiply(scale).value();
    const scaledPreNum = numeral(preNum).multiply(scale).value();

    const growth = numeral(scaledCurrNum).subtract(scaledPreNum).divide(scaledPreNum).value();

    return growth;
  } catch (err) {
    console.error('calculGrowth Err:', err);
  }
};

export const computePrecent = (num, total) => {
  let precent = 0;
  if (total != 0) {
    precent = num / total;
  }
  return precent;
};

export const upperFrist = (str) => {
  const newStr = str.split(' ');
  for (let i = 0; i < newStr.length; i++) {
    let item = newStr[i].slice(0, 1).toUpperCase() + newStr[i].slice(1).toLowerCase();
    if (item == 'Steamcharts') {
      item = 'Steam PCU';
    }
    newStr[i] = item;
  }
  return newStr.join(' ');
};

export const findNum = (num) => {
  const numStr = `${num}`;
  let reNum = '';
  if (num < 100000) {
    reNum = Number(numStr.substr(0, 1)) + 1;
  } else {
    reNum = Number(numStr.substr(0, 2)) + 1;
  }
  while (reNum % 5 != 0) {
    reNum += 1;
  }
  reNum += '';
  while (reNum.length < numStr.length) {
    reNum += '0';
  }
  return Number(reNum);
};

export const getLineChartTime = (time) => {
  const temp = [];
  if (time) {
    temp.push(time);
    for (let i = 0; i < 5; i++) {
      time = moment(time).subtract(1, 'month').format('YYYY-MM-DD');
      temp.push(time);
    }
  }
  return temp;
};

export const getUrlParam = (key) => {
  const urlParmas = window.location.search;
  const arr = urlParmas.split('&');
  let ret = '';
  arr.map((item) => {
    if (item.indexOf(key) != -1) {
      ret = item.split('=')[1];
    }
  });
  return ret;
};

export const formatTime = (date) => {
  const monthDic = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };
  if (date && date.length == 2) {
    // 2022-05-01
    const timeS = `${monthDic[date[0].substr(5, 2)]},${date[0].substr(0, 4)}`;
    const timeE = `${monthDic[date[1].substr(5, 2)]},${date[1].substr(0, 4)}`;
    if (timeS == timeE) {
      return timeS;
    }
    return `${timeS} ~ ${timeE}`;
  }
  const now = new Date();
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  if (month >= 1 && month <= 9) {
    // @ts-ignore
    month = `0${month}`;
  }
  return `${monthDic[month]},${year}`;
};

const test = () => {
  const testArray = [
    {
      top_free: 11,
      top_grossing: 3,
      top_paid: 6,
    },
    {
      top_free: 11,
      top_grossing: 2,
      top_paid: 3,
    },
    {
      top_free: 11,
      top_grossing: 3,
      top_paid: 4,
    },
    {
      top_free: 10,
      top_grossing: 3,
      top_paid: 4,
    },
  ];
  const a = testArray.sort(sortTest('mobile'));
};

export const pcHasDataCountry = [
  'us',
  'th',
  'pt',
  'ru',
  'sa',
  'at',
  'nl',
  'kr',
  'se',
  'ie',
  'br',
  'pl',
  'cl',
  'fr',
  'co',
  'ar',
  'hu',
  'jp',
  'gb',
  'ae',
  'ch',
  'es',
  'nz',
  'ca',
  'cz',
  'tr',
  'be',
  'no',
  'fi',
  'dk',
  'it',
  'mx',
  'za',
  'il',
  'au',
  'de',
  'id',
];

export const formatP = (num) => {
  if (typeof num !== 'number') return num;
  const _num = new Number(num);
  let _percentage = 0;
  // @ts-ignore
  if (Math.abs(_num) > 0 && Math.abs(_num) < 0.01) {
    // 四舍五入保留两位小数
    // @ts-ignore
    _percentage = (Math.round(Math.abs(_num) * 10000) / 100).toFixed(2) - 0;
    // _percentage = Math.abs(Math.round((_num) * 100));
  } else {
    // @ts-ignore
    _percentage = Math.abs(Math.round(_num * 100));
  }
  return _percentage > 99999 ? '99999+' : `${_percentage}`;
};

export const getBgImg = (item: any) => {
  const entity_image = item?.entity_image;
  let imgB = '';
  if (entity_image) {
    const imgArr = entity_image?.split('|');
    if (imgArr && imgArr.length >= 1) {
      imgB = imgArr[0];
    }
  }
  return imgB;
};

export const platImg = (data: any) => {
  const type = data.chart_type || data.chat_type;
  if (type) {
    if (type.toLowerCase().indexOf('appstore') != -1) {
      return appstore;
    }
    if (type.toLowerCase().indexOf('googleplay') != -1) {
      return googleplay32;
    }
    if (type.toLowerCase().indexOf('newzoo') != -1) {
      return newzoo;
    }
    if (type.toLowerCase().indexOf('mscience') != -1) {
      return mscience;
    }
    if (type.toLowerCase().indexOf('steam') != -1) {
      return steam;
    }
    if (type.toLowerCase().indexOf('epic') != -1) {
      return epic;
    }
    if (type.toLowerCase().indexOf('playstation') != -1) {
      return playstation;
    }
    if (type.toLowerCase().indexOf('xbox') != -1) {
      return xbox;
    }
    return googleplay32;
  }
  return googleplay32;
};

export const getValue = (item: any) => {
  const value = item?.chart_value || item?.chat_value || 0;
  const type = item?.chart_type || item?.chat_type || 0;
  let reValue = ' - ';
  if (value != 0) {
    if (type.indexOf('steam') != -1) {
      reValue = ` ${formatNum(value, true)}`;
    } else {
      reValue = ` #${value}`;
    }
  }
  // formatNum
  return reValue;
};

// 转换时间格式，剔除日，转换为月
export const convertDateFormat = (_date: any) => {
  const converter = (dateStr: any) => {
    if (!dateStr) return '';
    const month = moment(dateStr).get('month') + 1;
    const year = moment(dateStr).get('year');
    return `${year}-${month > 9 ? month : `0${month}`}-01`;
  };
  let startDate = _date || '';
  let endDate = _date || '';
  if (_date.match(',')) {
    const [_start, _end] = _date.split(',') || [];
    startDate = _start;
    endDate = _end;
  }
  return {
    startDate: converter(startDate),
    endDate: converter(endDate),
  };
};

// 计算stats %
export const computeSpecialPercent = (
  nowData: any,
  preData: any,
  key: string,
  preKey: string,
  granularity: string,
) => {
  let precent = 0;
  if (!preData) {
    return precent;
  }
  const nowValue = nowData[key];
  const nowDate = nowData.date;
  let preDate = '';
  if (granularity == 'monthly') {
    preDate = moment(nowDate).subtract(1, 'month').format('YYYY-MM-DD');
  } else if (granularity == 'weekly') {
    preDate = moment(nowDate).subtract(7, 'days').format('YYYY-MM-DD');
  } else if (granularity == 'daily') {
    preDate = moment(nowDate).subtract(1, 'days').format('YYYY-MM-DD');
  }
  let preValue = 0;
  preData.map((item) => {
    if (item.date == preDate) {
      preValue = item[preKey];
    }
  });
  precent = computePrecentChange(nowValue, preValue);
  return precent;
};

// 由于初始化时，将每一项做了格式化，详见src/pages/intelligence/pages/MarketProfile/hooks/useMobileGamesModel.tsx的filterData方法
// 所以这里格式化成一致的，防止后加入的项取marketEn取空
// map返回的...item是兜底
export const formatTableSelected = (selectedItems: any) =>
  selectedItems.map((item: any) => {
    const { gameId, marketEn, color, marketNameEn } = item;
    return {
      gameId,
      marketEn: marketEn || marketNameEn,
      color,
      ...item,
    };
  });

export interface MetricItem {
  metric: 'sensortower_revenue' | 'sensortower_download' | 'appannie_revenue' | 'appannie_download';
  value: number;
}

export interface CountryData {
  marketEn: string;
  metric_list?: MetricItem[];
}

export type ConvertedData = Record<
  string,
  {
    revenue: number[];
    download: number[];
  }
>;

/**
 * 将表格数据转换为国家维度的收益/下载统计数据
 * @param originalData - MarketProfile组件的表格数据数组
 * @returns 返回一个对象，包含每个国家的 revenue 和 download 数据
 */
export const convertMetricsTS = ({
  originalData,
}: {
  originalData?: CountryData[];
}): ConvertedData | undefined => {
  return originalData?.reduce((acc, country) => {
    const countryKey = country.marketEn;

    if (!acc[countryKey]) {
      acc[countryKey] = { revenue: [], download: [] };
    }

    country.metric_list?.forEach((metric) => {
      if (metric.metric === 'sensortower_revenue' || metric.metric === 'appannie_revenue') {
        acc[countryKey].revenue.push(metric.value);
      } else if (
        metric.metric === 'sensortower_download' ||
        metric.metric === 'appannie_download'
      ) {
        acc[countryKey].download.push(metric.value);
      }
    });

    return acc;
  }, {} as ConvertedData);
};

export type TCountryInfo = {
  country_name_abbre: string;
  country_name_cn: string;
  country_name_en: string;
  intel_region_abbre: string;
  intel_region_name_cn: string;
  intel_region_name_en: string;
};

/**
 * 根据国家缩写或市场名称查询国家信息
 * @param params 包含以下属性的对象:
 * @param params.countryMap 国家信息数据源数组
 * @param params.abbr [可选] 按国家缩写查询（精确匹配）
 * @param params.marketCn [可选] 按中文市场名称查询（精确匹配）
 * @param params.marketEn [可选] 按英文市场名称查询（精确匹配）
 * @returns 首个匹配的国家信息对象，未找到时返回 undefined
 *
 * @description
 * 该函数支持多条件组合查询：
 * 1. 当某个查询参数未传递时，该条件会自动通过（视为不限制该条件）
 * 2. 多个查询条件之间为"与"关系，需同时满足
 * 3. 使用数组的find方法返回首个匹配项
 */
export const getCountryByName = (params: {
  countryMap: TCountryInfo[];
  abbr?: string;
  marketCn?: string;
  marketEn?: string;
}): TCountryInfo | undefined => {
  const { countryMap, abbr, marketCn, marketEn } = params;

  // 构造三个匹配条件（如果查询参数存在则严格匹配，否则返回true）

  return countryMap.find((item) => {
    const abbrMatch = abbr ? item.country_name_abbre.toLowerCase() === abbr.toLowerCase() : true;
    const cnMatch = marketCn ? item.intel_region_name_cn === marketCn : true;
    const enMatch = marketEn
      ? item.intel_region_name_en.toLowerCase() === marketEn.toLowerCase()
      : true;

    return abbrMatch && cnMatch && enMatch;
  });
};

export const convertStringToCountries = ({
  searchKey,
  allCountries,
}: {
  searchKey: string;
  allCountries: CountryItem[];
}): CountryItem[] => {
  const res = allCountries.filter(
    (country) =>
      country?.name.toLowerCase().includes(searchKey?.toLowerCase()) ||
      country?.enName.toLowerCase().includes(searchKey?.toLowerCase()),
  );

  return res;
};

// 对调指标位置
export function sortMetrics(metricConfig) {
  metricConfig.forEach((category) => {
    if (category.children && Array.isArray(category.children)) {
      category.children.sort((a, b) => {
        if (a.label === 'download' && b.label === 'revenue') return 1;
        if (a.label === 'revenue' && b.label === 'download') return -1;
        return 0;
      });
    }
  });
  return metricConfig;
}

export const getPieces = (list?: any[] | null) => {
  const nums = list?.map((item) => {
    return Number.parseFloat(item?.value);
  });
  return getPiecesDefault(nums);
};
